import axios from 'axios'
import StorageService from '../services/storage'
import miniToastr from './minitoastr'
import _ from 'lodash'

const formatErrors = (errors) => {
  let currentErrors = []
  _.forEach(errors.errors, err => {
    currentErrors.push(`${err.param} - ${err.msg}`)
  })
  let htmlErrors = currentErrors.toString().split(',').join('<hr/>')
  return htmlErrors
}

const handleError = (error) => {
  switch (error.response.status) {
    case 404:
      miniToastr.warn(formatErrors(error.response.data))
      break
    case 401:
      miniToastr.error(formatErrors(error.response.data), 'Unauthorized')
      break
    case 403:
      miniToastr.error(formatErrors(error.response.data), 'Forbidden')
      break
    case 422:
      miniToastr.warn(formatErrors(error.response.data), 'Unprocessable Entity')
      break
    case 500:
      miniToastr.error(formatErrors(error.response.data), 'Internal Server Error')
      break
    default:
      miniToastr.error(formatErrors(error.response.data), 'Unknown Error')
  }
}

class AxiosForMobile {
  constructor () {
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL.replace(/\/api\//g, '/api_mobile/'),
      timeout: 300000,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    this.instance.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response) {
        handleError(error)
      } else if (error.request) {
      } else {
      }
      return Promise.reject(error)
    })
  }

  base () {
    return this.instance
  }

  authenticated () {
    console.log(StorageService.getItem('mobileToken'))
    this.instance.defaults.headers.common['Authorization'] = `Bearer ${StorageService.getItem('mobileToken')}`
    return this.instance
  }
}

export default new AxiosForMobile()
